import Pageable from "@/mixins/pageable";
import { KPageIndex } from "kinnect-general";

export default {
	name: "WarehouseReportsPage",

	metaInfo: { title: "Warehouse - Reports" },

	mixins: [ Pageable ],

	data: () => ( {
		items: [
			{
				title: "Outbound Freight",
				icon: "all_inbox",
				to: { name: "warehouseOutboundFreightReport" }
			}
		]
	} ),

	render() {
		return <KPageIndex items={this.items}></KPageIndex>;
	}
};
